const backendUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000/api"
    : "https://seashell-app-lysog.ondigitalocean.app/api";

export default backendUrl;
